import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';

import { DocCardComponent } from './doc-card.component';
import { FeatureCardComponent } from './feature-card.component';
import { StatisticsCardComponent } from './statistics-card.component';

@NgModule({
  imports: [CommonModule, NzCardModule, NzIconModule, NzGridModule],
  declarations: [DocCardComponent, FeatureCardComponent, StatisticsCardComponent],
  exports: [DocCardComponent, FeatureCardComponent, StatisticsCardComponent]
})
export class MStatisticsModule {}
